import React from "react";
import { Link } from "react-router-dom";
import { firstThreeDays } from "../mock";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

export default function FirstThreeDays() {
  return (
    <section className="relative py-24 md:py-36 overflow-hidden bg-gradient-to-b from-[#486a8f] to-[#3e5f82] text-white">
      <div
        className="absolute inset-0 opacity-[0.12] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 10%, rgba(255,255,255,0.6) 0%, transparent 40%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.3) 0%, transparent 45%)",
        }}
      />
      <div className="relative max-w-4xl mx-auto px-6">
        <Reveal>
          <div className="text-center mb-20">
            <p className="font-mono-eyebrow text-white/70 mb-4">Your first 3 days</p>
            <h2 className="font-display text-[40px] md:text-[56px] leading-[1.05] tracking-tight">
              What happens when{" "}
              <span className="italic font-light">you start</span>
            </h2>
          </div>
        </Reveal>

        <div className="relative">
          {/* vertical line */}
          <div className="absolute left-[35px] md:left-[60px] top-2 bottom-2 w-px bg-white/30" />

          <div className="space-y-12 md:space-y-16">
            {firstThreeDays.map((d, i) => (
              <Reveal key={d.day} delay={i * 0.1}>
                <div className="relative flex gap-6 md:gap-10 items-start">
                  <div className="relative z-10 shrink-0">
                    <div className="w-[70px] h-[70px] md:w-[120px] md:h-[120px] rounded-full bg-[#486a8f] border-2 border-white/60 flex items-center justify-center text-white">
                      <span className="font-display text-[13px] md:text-[17px] tracking-wide">
                        {d.day}
                      </span>
                    </div>
                  </div>
                  <div className="pt-2 md:pt-6">
                    <h3 className="font-display text-[22px] md:text-[32px] leading-tight tracking-tight mb-2 md:mb-3">
                      {d.title}
                    </h3>
                    <p className="font-body text-[15px] md:text-[17px] text-white/85 max-w-xl leading-relaxed">
                      {d.description}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal>
          <div className="mt-20 text-center">
            <Link to="/start">
              <Button className="group h-14 px-8 rounded-full bg-white hover:bg-[#f7f3ea] text-[#486a8f] font-medium text-[15px] btn-lift">
                Start Free 3-Day Trial
                <ArrowRight
                  size={17}
                  className="ml-2 transition-transform duration-300 group-hover:translate-x-1"
                />
              </Button>
            </Link>
            <p className="font-body text-[13px] text-white/70 mt-4">
              No charge today. Plans from $8.88/month after trial unless cancelled.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
